<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 text-nomal">교육대상</h3>
		<div class="white-box clearfix">
			<p class="f-14 m-b-5">
				<img src="images/s-check2.png" alt="">
				신청인
			</p>
			<div class="round">
				<textarea class="full-width editorLesTargetDetail" cols="30" rows="4"></textarea>
			</div>
		</div>
		<div class="white-box clearfix">
			<p class="f-14 m-b-5">
				<img src="images/s-check2.png" alt="">
				교육대상
			</p>
			<div class="input-group m-b-10">
				<span class="input-group-addon">
					<input id="check1" class="checkbox3-sm" type="radio" name="student" value="개인수강생" v-model="data.lesTargetType">
					<label for="check1" class="v-mid">개인수강생</label>
				</span>
				<span class="input-group-addon">
					<input id="check2" class="checkbox3-sm" type="radio" name="student" value="단체수강생" v-model="data.lesTargetType">
					<label for="check2" class="v-mid m-l-5">단체수강생</label>
				</span>
			</div>
			<div class="round">
				<div id="lesTargetDetail"></div>
				<!--<textarea class="full-width" cols="30" rows="10" v-model="data.lesTargetDetail"></textarea>-->
			</div>
		</div>

		<!-- button wrapper -->
		<!-- <button class="btn btn-red round m-t-30 pull-left" type="button" @click="setInitValue">초기값으로 설정</button> -->
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="nextStep">저장하고 넘어가기</button>
		<button class="btn round m-t-30 m-r-5 pull-right" type="button" @click="skipStep">건너뛰기</button>
	</div>
</template>

<script>
import fnTextEditor from '../../mixins/fnTextEditor'
export default {
	name: "SubviewClassRegisterStep_3",
	mixins: [fnTextEditor],
	data: function() {
		return {
			data: {
				lesTargetWork: this.classData.lesTargetWork,
				lesTargetType: this.classData.lesTargetType,
				lesTargetDetail: this.classData.lesTargetDetail,
			},
			selectedJob: -1,
			jobs_: JSON.parse(JSON.stringify(this.jobs)),
			editorLesTargetDetail: null
		}
	},
	props: {
		classData: Object,
		jobs: Array,
		default: Object
	},
	mounted: function() {
		this.data.lesTargetWork.split(",").forEach(jobCode => {
			if(jobCode) this.$set(this.jobs_.find(job => job.code == jobCode), "isSelected", true);
		});
		this.initEditor({
			selector:'.editorLesTargetDetail', 
			contentName:'lesTargetDetail',
			editorContentName: 'editorLesTargetDetail'
		});
	},
	methods: {
		setInitValue: function(){
			this.data.lesTargetWork = this.default.lesTargetWork;
			this.data.lesTargetType = this.default.lesTargetType;
			this.data.lesTargetDetail = this.default.lesTargetDetail;
			this.editorLesTargetDetail.html.set(this.data.lesTargetDetail);
		},
		addJob: function() {
			if(this.selectedJob!=-1)
				this.$set(this.jobs_[this.selectedJob], "isSelected", true);
			this.selectedJob = -1;
		},
		removeJob: function(job) {
			job.isSelected = false;
		},
		skipStep: function() {
			this.$emit("skipStep", {});
		},
		nextStep: function() {
			// this.data.lesTargetWork = "";
			// this.jobs_.forEach(job=>{
			// 	if(job.isSelected)
			// 		this.data.lesTargetWork += this.data.lesTargetWork==""?job.code:","+job.code;
			// });
			// if(this.data.lesTargetWork=="") {
			// 	this.$emit("alert", "교육대상 직업군을 선택하세요.");
			// 	return;
			// }
			if(this.data.lesTargetType=="") {
				this.$emit("alert", "신청자격을 선택하세요.");
				return;
			}
			if(this.data.lesTargetDetail.trim().length==0) {
				this.$emit("alert", "교육대상 안내문구를 입력하세요.");
				return;
			}
			this.$emit("nextStep", this.data);
		}
	}
}
</script>

<style scoped>
span.input-group-addon.v-mid.text-white div { height:40px; }
</style>